export { default } from './EmprestimoGarantiaCarroContrato';
